import { AxiosResponse } from "axios";
import { call } from "redux-saga/effects";
import { automaticApi } from "@/settings/api";
import { CreateAccountResponse } from "./create";

export interface ResolvedAccount {
  customerId: string;
  accountId: string;
}

export default function* resolveLoggedAccount(
  nrc?: string,
): Generator<
  ReturnType<typeof call>,
  ResolvedAccount | null,
  AxiosResponse<CreateAccountResponse>
> {
  try {
    if (!nrc) throw new Error();

    const response = yield call(
      automaticApi.post,
      `/internalwebapi/v1/customers/${nrc}/accounts`,
      {
        isAcceptedTerms: true,
        isAcceptedPrivacy: true,
      },
    );

    const accountId = response?.data?.data?.accountIdentification;
    if (!accountId) throw new Error();

    return {
      customerId: nrc,
      accountId,
    };
  } catch (error) {
    return null;
  }
}
